var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCheck2 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.7331C5.39685 18.7331 1.66602 15.0022 1.66602 10.3997C1.66602 5.79724 5.39685 2.06641 9.99935 2.06641C14.6018 2.06641 18.3327 5.79724 18.3327 10.3997C18.3327 15.0022 14.6018 18.7331 9.99935 18.7331ZM9.16852 13.7331L15.0602 7.84057L13.8819 6.66224L9.16852 11.3764L6.81102 9.01891L5.63268 10.1972L9.16852 13.7331Z",
    fill: "#38A169"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCheck2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/check-2.4f5d4758.svg";
export { ForwardRef as ReactComponent };